import Firebase from 'firebase'

let config = {
  apiKey: 'AIzaSyAcJIKyf-HNw3xe9g4q0U2GwlTCw-qVO2c',
  authDomain: 'radio-corpus.firebaseapp.com',
  databaseURL: 'https://radio-corpus.firebaseio.com',
  projectId: 'radio-corpus',
  storageBucket: 'radio-corpus.appspot.com',
  messagingSenderId: '47320032718',
  appId: '1:47320032718:web:54313418efcff19669779f',
  measurementId: 'G-ZZVSNQRY1F'
}
let app = Firebase.initializeApp(config)
let db = app.database()
let auth = app.auth()
let storageRef = app.storage().ref()
export { db, storageRef, auth }
